"use strict";

var _classCallCheck = require("/tmp/3e4ae11a/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/3e4ae11a/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/tmp/3e4ae11a/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/tmp/3e4ae11a/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/tmp/3e4ae11a/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/tmp/3e4ae11a/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var cheerio = require("cheerio");

var service_1 = require("./service");

var LinkedIn =
/*#__PURE__*/
function (_service_1$Service) {
  _inherits(LinkedIn, _service_1$Service);

  function LinkedIn() {
    _classCallCheck(this, LinkedIn);

    return _possibleConstructorReturn(this, _getPrototypeOf(LinkedIn).apply(this, arguments));
  }

  _createClass(LinkedIn, null, [{
    key: "getBaseUrls",
    value: function getBaseUrls() {
      var baseUrls = ['https://www.linkedin.com/feed/update/', 'http://www.linkedin.com/feed/update/', 'www.linkedin.com/feed/update/'];
      return baseUrls;
    }
  }, {
    key: "getProofUrl",
    value: function getProofUrl(proof) {
      var baseUrls = this.getBaseUrls();
      var proofUrl = proof.proof_url.toLowerCase();
      proofUrl = _get(_getPrototypeOf(LinkedIn), "prefixScheme", this).call(this, proofUrl);

      for (var i = 0; i < baseUrls.length; i++) {
        if (proofUrl.startsWith("".concat(baseUrls[i]))) {
          return proofUrl;
        }
      }

      throw new Error("Proof url ".concat(proof.proof_url, " is not valid for service ").concat(proof.service));
    }
  }, {
    key: "normalizeUrl",
    value: function normalizeUrl(proof) {
      return '';
    }
  }, {
    key: "shouldValidateIdentityInBody",
    value: function shouldValidateIdentityInBody() {
      return true;
    }
  }, {
    key: "getProofIdentity",
    value: function getProofIdentity(searchText) {
      var $ = cheerio.load(searchText);
      var profileLink = $('body > main header a');

      if (profileLink !== undefined) {
        if (profileLink.attr('href') === undefined) {
          return '';
        }

        var url = profileLink.attr('href'); // Parse URL for identifier

        var identifier = url.split('?').shift().split('/').pop();
        return identifier;
      } else {
        return '';
      }
    }
  }, {
    key: "getProofStatement",
    value: function getProofStatement(searchText) {
      var $ = cheerio.load(searchText);
      var postContent = $('head > meta[property="og:title"]');
      var statement = '';

      if (postContent !== undefined) {
        statement = postContent.attr('content');
      }

      return statement;
    }
  }]);

  return LinkedIn;
}(service_1.Service);

exports.LinkedIn = LinkedIn;